import { Map } from "immutable";

import actionTypes from "../../../action-types";
import { Memories } from "../../../models/state/memories/Memories";
import Memory from "../../../models/state/memories/memory/Memory";

export default function memoriesReducer(
  stored: Memories = Map<string, Memory>(),
  action: Record<string, any>
) {
  switch (action.type) {
    case actionTypes.SAVE_MEMORY:
      const memoryData = action.payload;
      return stored.set(memoryData.sectionId, new Memory(memoryData));

    case actionTypes.RECEIVE_MEMORIES:
      return action.payload.memories.reduce(
        (init: any, memory: any) =>
          init.set(memory.sectionId, new Memory(memory)),
        stored
      );

    case actionTypes.RECONCILE_MEMORIES:
      return action.payload.memories.reduce(
        (init: any, memory: any) =>
          init.set(memory.sectionId, new Memory(memory)),
        Map()
      );

    default:
      return stored;
  }
}
